import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class BacktestService {
  async getHistoricalPrices(tickers, period = '5y') {
    try {
      const tickerString = Array.isArray(tickers) ? tickers.join(',') : tickers;
      const response = await axios.get(`${API}/backtest/historical-prices`, {
        params: {
          tickers: tickerString,
          period: period
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching historical prices:', error);
      throw error;
    }
  }

  async getBenchmarkData(period = '5y', symbol = '^GSPC') {
    try {
      const response = await axios.get(`${API}/backtest/benchmark`, {
        params: {
          symbol: symbol,
          period: period
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching benchmark data:', error);
      throw error;
    }
  }
}

export default new BacktestService();
